import React, { useMemo, useState } from 'react'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import { percentage, reportingPercentage, percentageAsBps } from '../model/utils/formatters'
import ResultsComposedChart from './charts/ResultsComposedChart'
import ChartCard from './components/ChartCard'
import Button from '../../atoms/button/Button'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import ResultsTable from './table/ResultsTable'
import { TeamsWithColours } from './RoundResults'

import Theme from '../../../styles/_theme.module.scss'
import { getYAxisDataV2 } from './charts/yaxis'

interface Props {
  teams: TeamsWithColours[]
  marketMargins: ModelAPI.Reporting.MarketMargins
  pastRound1: boolean
}

const getChangeColour = (change: number): string => {
  return change === 0 ? 'black' : change > 0 ? Theme.green : Theme.red
}

const RoundResultsNetInterestMargin: React.FC<Props> = ({
  teams,
  marketMargins,
  pastRound1
}) => {
  const [showMargins, setShowMargins] = useState(false)
  const humanTeams = useMemo(() => teams.filter(t => !t.isCpuTeam), [teams])

  const data = useMemo(() => {
    return marketMargins.data.map(d => {
      const margin = Number(percentage(d.margin, 2, true, true))
      const cost = Number(percentage(d.cost, 2, true, true))
      const rate = cost + margin
      return {
        name: d.name,
        net: [
          cost,
          rate
        ],
        rate,
        cost,
        margin,
        midpoint: cost + (margin / 2)
      }
    })
  }, [marketMargins])

  const { minValue, maxValue, numberOfTicks } = getYAxisDataV2({
    pastRound1,
    isPercentage: true,
    data: data.map(d => ({
      name: 'Anything',
      min: d.net[0],
      max: d.net[1]
    }))
  })

  return (
    <VerticalGroup full center wide>
      <ChartCard
        heading='Market Margins'>
        <ResultsComposedChart
          data={data}
          formatter={(val: number) => reportingPercentage(val)}
          yAxisFormatter={(val: number) => reportingPercentage(val, 1)}
          // figure out how to get these values like with yaxis.ts
          minYAxisvalue={minValue}
          maxYAxisvalue={maxValue}
          numberOfTicks={numberOfTicks}
        />
        <InlineGroup block center verticalCenter className='mt-2' style={{height: '30%', width: '90%'}} >
          {showMargins ? (
            <ResultsTable id='999'>
              <thead>
                <tr>
                  {humanTeams.map(t => (<th key={t.teamId}>{t.teamName}</th>))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {humanTeams.map(t => (<th key={t.teamId} style={{ color: getChangeColour(marketMargins.teams[t.teamId - 1].change) }}>{marketMargins.teams[t.teamId - 1].change === 0 ? 'No Change' : percentageAsBps(marketMargins.teams[t.teamId - 1].change, 2)}</th>))}
                </tr>
                <tr>
                  {humanTeams.map(t => (<th key={t.teamId}>{percentage(marketMargins.teams[t.teamId - 1].margin, 2)}</th>))}
                </tr>
              </tbody>
            </ResultsTable>
          ) : (

            <Button onClick={() => setShowMargins(true)}>Show Margins</Button>

          )}

        </InlineGroup>
      </ChartCard>

    </VerticalGroup>
  )
}

export default RoundResultsNetInterestMargin